import styled from "@emotion/styled";
import { fontRobotoCondensed } from "@product/scmp-sdk";

import { BaseLink } from "scmp-app/components/common/base-link";

import ImagePlaceholder from "./img-placeholder.svg";

export const Container = styled.div`
  display: flex;
  flex-flow: column nowrap;
  row-gap: 12px;

  inline-size: 100%;
  block-size: 100%;
  block-size: auto;
  padding: 28px;

  border-radius: 12px;

  background-color: #ecebe3;
`;

export const HeaderContainer = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: flex-start;

  column-gap: 12px;
`;

export const Title = styled.div`
  grid-area: header;

  color: #000000;
  font-weight: 700;
  font-size: 14px;
  font-family: ${fontRobotoCondensed};
  text-transform: uppercase;
`;

export const Filter = styled.div`
  grid-area: filter;

  flex: 1 1 auto;
`;

export const AgendaContainer = styled.div`
  grid-area: events;

  display: flex;
  flex: 1 1 auto;
  flex-flow: column nowrap;
  row-gap: 8px;

  margin-block-start: 4px;
  margin-inline-end: -18px;
  padding-inline-end: 18px;

  overflow-y: auto;
`;

export const StyledBaseLink = styled(BaseLink)`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  align-self: flex-end;

  margin-block: 13px;

  color: #4585ff;
  font-weight: 700;
  font-size: 16px;
  font-family: ${fontRobotoCondensed};
  text-decoration-line: underline;
`;

export const PlaceHolderContainer = styled.div``;

export const StyledImagePlaceholder = styled(ImagePlaceholder)``;
